import Showdown from "showdown";

const htmlConverter = new Showdown.Converter({
    simpleLineBreaks: true,
    strikethrough: true,
});

export function markdownToHtmlForSlack(markdown: string): string {
    return htmlConverter.makeHtml(markdown);
}

export function markdownToSlackMrkdwn(markdown: string): string {
    return markdown
        .replace(/\*\*(.+?)\*\*/g, "*$1*")
        .replace(/__(.+?)__/g, "*$1*")
        .replace(/~~(.+?)~~/g, "~$1~")
        .replace(/\[([^\]]+)\]\(([^)]+)\)/g, "<$2|$1>")
        .replace(/^#{1,6}\s+(.+)$/gm, "*$1*")
        .replace(/^\s*[-*+]\s+/gm, "• ");
}
